/* eslint-disable camelcase */
import { get } from 'lodash';
import { normalize } from 'normalizr';

import { displayXhrError } from 'hb-react/frontoffice/utils/globalUtils';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import * as actionTypes from '../constants/ActionTypes';
import Schemas from '../reducers/schema';

/* ------------------------------------- */
// Load all topics
/* ------------------------------------- */

export const resetingTopics = () => ({
  type: actionTypes.RESETING_TOPICS,
});

export const fetchingTopics = () => ({
  type: actionTypes.FETCHING_TOPICS,
});

export const fetchedTopics = (topics, total_items, options) => ({
  type: actionTypes.FETCHED_TOPICS,
  payload: { topics, total_items, options },
});

export const fetchTopicsIfNeeded =
  (params = {}) =>
  (dispatch, getState) => {
    if (shouldFetchTopics(getState())) return dispatch(fetchTopics(params));
  };

export const fetchTopics =
  (params = {}) =>
  (dispatch, getState) => {
    params.format = 'json';
    params.page = getState().topics.get('page');

    dispatch(fetchingTopics());

    return axios
      .get(Routes.topics_topics_path(params))
      .then(
        (response) =>
          dispatch(
            fetchedTopics(
              normalize(response.data, Schemas.TOPICS),
              response.data.total_items,
            ),
          ),
        displayXhrError,
      );
  };

const shouldFetchTopics = (state) =>
  state.topics.get('can_load_more_topics') &&
  !state.topics.get('no_more_topics');

/* ------------------------------------- */
// Load specific topic
/* ------------------------------------- */

export const fetchingTopic = (topic_id) => ({
  type: actionTypes.FETCHING_TOPIC,
  payload: topic_id,
});

export const fetchedTopic = (topic) => ({
  type: actionTypes.FETCHED_TOPIC,
  payload: topic,
});

export const selectTopic = (topic_id) => ({
  type: actionTypes.SELECT_TOPIC,
  payload: topic_id,
});

export const fetchTopicIfNeeded =
  (topic_id, options) => (dispatch, getState) => {
    if (shouldFetchTopic(getState(), topic_id)) {
      return dispatch(fetchTopic(topic_id, options));
    }

    return dispatch(
      fetchedTopic(
        normalize(
          {
            topics: [
              getState().topics.getIn(['topics', topic_id.toString()]).toJS(),
            ],
          },
          Schemas.TOPICS,
        ),
      ),
    );
  };

export const fetchTopic = (topicId, options) => (dispatch) => {
  const whitelabelURL = get(options, 'whitelabelURL', false);
  const {
    location: { origin },
  } = window;
  let url;

  dispatch(fetchingTopic(topicId));
  if (!AlumniConnect.currentUser) {
    url = Routes.topic_path(topicId);
  } else {
    url = Routes.topics_topic_path(topicId);
  }

  url = whitelabelURL ? origin : url;

  const params = {
    format: 'json',
    members_limit: options?.flags?.flagUjbGroupHeaderRedesign ? 3 : 2,
  };

  return axios
    .get(url, { params })
    .then((response) =>
      dispatch(
        fetchedTopic(
          normalize({ topics: [response.data.topic] }, Schemas.TOPICS),
        ),
      ),
    );
};

const shouldFetchTopic = (state, topicId) =>
  !state.topics.getIn(['topics', topicId.toString(), 'fetched_at']);
